export default __webpack_public_path__ + "static/media/include_13_female@3x.b3c46fe6.jpg";